import React, { useState } from "react";
import style from "css/solution.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination } from "swiper/modules";
import Questions from "components/app/questions";
import SEOMeta from "components/app/SEOMeta";
import { useMediaQuery } from "react-responsive";

function CmsManager() {
  const isMobile = useMediaQuery({ query: "(max-width: 889px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 890px) and (max-width: 1599px)",
  });
  const [activeIdx, setActiveIdx] = useState(0);
  const [controlledSwiper, setControlledSwiper] = useState(null);

  return (
    <>
      <SEOMeta
        title="CMS Manager, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - CMS Manager"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, CMS Manager, Cisco, Ciso Meeting Server"
      />
      <section className={style.wrapper}>
        <section className={`${style.container} ${style.cmsmanager_content}`}>
          <section className={style.banner_section}>
            <article className={style.banner_article}>
              <div className={style.banner_title}>
                <p>관리자 영상회의 운영 최적화 솔루션,</p>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/logo.png`}
                  alt="logo"
                />
                <p>
                  CMS Manager는{"\n"} Cisco Meeting Server의 운용 및 관리를 위한
                </p>
                <p>관리자 전용 시스템입니다.</p>
              </div>
              <div className={style.banner_company}>
                <p>Trusted by many companies</p>
                <div className={style.banner_company_ci}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_president.png`}
                    alt="청와대"
                  />
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_mfds.png`}
                    alt="식품의약품안전처"
                  />
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_kdca.png`}
                    alt="질병관리청"
                  />
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_posco.png`}
                    alt="포스코플랜텍"
                  />
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_lg.png`}
                    alt="LG화학"
                  />
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_lotte.png`}
                    alt="Lotte World Tower"
                  />
                </div>
              </div>
            </article>
            <img
              src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/banner.png`}
              alt="banner"
            />
          </section>
          <section className={style.description_section}>
            <article className={style.description_article}>
              <p>
                CMS Server가{"\n"} <font>직접 지원하지 않는</font>
              </p>
              <p>
                <font>
                  하드웨어 단말(Codec)의 등록과{"\n"} 모니터링을 위한 기능을
                  제공
                </font>
                하여
              </p>
              <p>
                <font>CMS 관리자</font>에게는{"\n"} 필수적인 솔루션 입니다.
              </p>
            </article>
            <p className={style.description_comment}>관리자 계정만 제공</p>
            <section className={style.description_item_section}>
              <div className={style.description_item_list}>
                <div className={style.description_item}>
                  <article className={style.description_item_article}>
                    <p>
                      실시간 회의 제어<font>Active Meeting</font>
                    </p>
                    <p>
                      실시간 회의 연동을 통한 효율적이고 편리한 회의 제어 및
                      관리
                    </p>
                  </article>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/desc_active_meeting.png`}
                    alt="Active Meeting"
                  />
                  <article className={style.description_item_article}>
                    <p>영상회의 제어</p>
                    <p>
                      영상회의 단말 연결/해제 · 음소거/비디오 · Mute · 녹화 ·
                      템플릿 변경 · 영상회의 단말 추가 연결 등의 기능 제공
                    </p>
                  </article>
                </div>
                <div className={style.description_item}>
                  <article className={style.description_item_article}>
                    <p>CDR Provide</p>
                    <p>
                      실시간 회의 연동을 통한 효율적이고 편리한 회의 제어 및
                      관리
                    </p>
                  </article>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/desc_cdr_provider.png`}
                    alt="Active Meeting"
                  />
                  <article className={style.description_item_article}>
                    <p>통계</p>
                    <p>
                      회의 시작/종료 시간 · 총 사용시간 · 초 단위 · Call ID ·
                      Co-Space · 참석자 수 관련 정보 제공
                    </p>
                  </article>
                </div>
              </div>
              <div className={style.description_item_list}>
                <div className={style.description_item}>
                  <article className={style.description_item_article}>
                    <p>CMS Management</p>
                    <p>
                      실시간 회의 연동을 통한 효율적이고 편리한 회의 제어 및
                      관리
                    </p>
                  </article>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/desc_cms_management.png`}
                    alt="Active Meeting"
                  />
                  <article className={style.description_item_article}>
                    <p>CMS 관리</p>
                    <p>
                      CMS 상태 관리 및 제어, 단말, 사용자 등록, 회의실 개설,
                      미팅 스케줄 관리 등의 기능 제공
                    </p>
                  </article>
                </div>
              </div>
            </section>
          </section>
          <section className={style.features_section}>
            <p className={style.features_title}>CMS Manager 특장점</p>
            <div className={style.features_btn_container}>
              <button
                className={
                  activeIdx === 0
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(0)}
              >
                1. 실시간 회의 제어
              </button>
              <button
                className={
                  activeIdx === 1
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(1)}
              >
                2. 레이아웃
              </button>
              <button
                className={
                  activeIdx === 2
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(2)}
              >
                3. Co-Space
              </button>
              <button
                className={
                  activeIdx === 3
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(3)}
              >
                4. 예약
              </button>
              <button
                className={
                  activeIdx === 4
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(4)}
              >
                5. 단말 관리
              </button>
              <button
                className={
                  activeIdx === 5
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(5)}
              >
                6. 통계
              </button>
            </div>
            <div className={style.features_swiper_container}>
              <Swiper
                className={style.features_swiper}
                spaceBetween={80}
                grabCursor={true}
                pagination={{
                  dynamicBullets: false,
                }}
                modules={[Pagination]}
                onSwiper={setControlledSwiper}
                onSlideChange={(swiper) => {
                  setActiveIdx(swiper.activeIndex);
                }}
              >
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        Active Meeting
                      </p>
                      <div className={style.features_swiper_item_title_txt}>
                        <p>진행중인 영상회의</p>
                        <p>실시간 제어 기능</p>
                      </div>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        <p>진행 중인 화상회의의 정보를 확인하고</p>
                        <p>회의의 세부 내용을 실시간으로 모니터링하며</p>
                        <p>제어할 수 있습니다.</p>
                      </div>
                      <div>
                        <p>
                          회의 참여 단말의{"\n"} 음소거, 비디오, 녹화, 추가 단말
                          연결 등
                        </p>
                        <p>다양한 제어 기능을 제공합니다.</p>
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/feature_active_meeting.png`}
                    alt="Active Meeting"
                  />
                </SwiperSlide>
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        레이아웃 배치 및 템플릿
                      </p>
                      <article className={style.features_swiper_item_title_txt}>
                        <p>진행 중인 영상회의</p>
                        <p>레이아웃 변경 및</p>
                        <p>단말 배치 기능</p>
                      </article>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        <p>
                          CMS Manager는 회의실 내{"\n"} 장비의 레이아웃 배치를
                        </p>
                        <p>쉽게 구성할 수 있는 기능을 제공하여,</p>
                        <p>최적화된 화면 배치와 사용자 경험을 보장합니다.</p>
                      </div>
                      <div>
                        <p>고객이 필요한 Layout 추가 요청 시,</p>
                        <p>별도 개발을 통해 구축 가능합니다.</p>
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/feature_layout.png`}
                    alt="Active Meeting"
                  />
                </SwiperSlide>
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        Co-Space
                      </p>
                      <article className={style.features_swiper_item_title_txt}>
                        <p>영상회의를 위한</p>
                        <p>회의실 관리</p>
                      </article>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        <p>회의실 생성 및 관리 기능을 제공하여,</p>
                        <p>새로운 회의실을 개설하고</p>
                        <p>그에 대한 정보를 손쉽게 관리할 수 있습니다.</p>
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/feature_cospace.png`}
                    alt="Active Meeting"
                  />
                </SwiperSlide>
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        영상회의 예약
                      </p>
                      <article className={style.features_swiper_item_title_txt}>
                        <p>영상회의</p>
                        <p>예약 / 수정 / 삭제</p>
                      </article>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        <p>예약 및 스케줄 관리 기능을 통해,</p>
                        <p>
                          간편하게 회의를 예약하고{"\n"} 일정을 관리할 수
                          있습니다.
                        </p>
                      </div>
                      <div>
                        <p>예약된 회의의 상세 정보를 조회하고,</p>
                        <p>필요에 따라 수정 또는 삭제할 수 있습니다.</p>
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/feature_reserve.png`}
                    alt="Active Meeting"
                  />
                </SwiperSlide>
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        단말 관리
                      </p>
                      <article className={style.features_swiper_item_title_txt}>
                        <p>영상회의</p>
                        <p>단말(코덱) 등록 관리</p>
                      </article>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        <p>
                          하드웨어 장비 등록 및 관리를 위한{"\n"} 기능을
                          제공하여,
                        </p>
                        <p>단말 장비의 등록, 수정, 삭제 등을</p>
                        <p>간편하게 처리할 수 있습니다.</p>
                      </div>
                      <div>
                        <p>이를 통해 CMS 서버와 연동된</p>
                        <p>모든 단말을 체계적으로 관리할 수 있습니다.</p>
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/feature_endpoint.png`}
                    alt="Active Meeting"
                  />
                </SwiperSlide>
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        통계
                      </p>
                      <article className={style.features_swiper_item_title_txt}>
                        <p>영상회의에 대한</p>
                        <p>CDR 기반 통계</p>
                      </article>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        <p>영상회의의 Call 정보에 대한 통계를 제공하여,</p>
                        <p>회의 사용 내역을 한눈에 파악할 수 있습니다.</p>
                      </div>
                      <div>
                        <p>
                          이 기능을 통해{"\n"} 모든 Call 정보의 리스트를
                          확인하고,
                        </p>
                        <p>
                          필요한 경우 엑셀로 다운로드하여{"\n"} 보고서를 생성할
                          수 있습니다.
                        </p>
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/feature_statistics.png`}
                    alt="Active Meeting"
                  />
                </SwiperSlide>
              </Swiper>
            </div>
          </section>
          <section className={style.case_study_section}>
            <p className={style.case_study_subtitle}>고객 사례</p>
            <p className={style.case_study_title}>
              CMS Manager <strong>Case Study</strong>
            </p>
            <div className={style.case_study_item}>
              <div className={style.case_study_description}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_p4g.png`}
                  alt="Case Study"
                />
                <p className={style.case_study_description_title}>
                  P4G 정상회의
                </p>
                <p className={style.case_study_description_subtitle}>
                  Customized Layout Type 개발 및 템플릿 적용
                </p>
                <article className={style.case_study_description_article}>
                  <div>
                    <p>리브테크놀로지는</p>
                    <p>P4G 정상회의에서 사용되는</p>
                    <p>Customized Layout Type을 개발,</p>
                  </div>
                  <div>
                    <p>이를 적용한 템플릿을 활용하여</p>
                    <p>
                      2021 P4G 서울 녹색미래 정상회의 협약 체결식 행사를
                      진행하였습니다.
                    </p>
                  </div>
                </article>
              </div>
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/case_study.png`}
                alt="Case Study"
              />
            </div>
          </section>
          <section className={style.partner_section}>
            <p className={style.partner_title}>Our Clients and Partners</p>
            <article className={style.partner_description}>
              <p>
                CMS Manager는 다양한 산업 분야에서{"\n"} 성공적으로 활용되고
                있는{"\n"}
                강력한 관리 솔루션입니다.
              </p>
              <p>
                우리의 고객들은 CMS Manager를 통해{"\n"} 모든 영상회의와 장비를
                통합 관리하며,{"\n"} 효율성과 생산성을 극대화하고 있습니다.
              </p>
              <p>
                CMS Manager를 선택한 고객들은{"\n"} 높은 만족도를 바탕으로,
                {"\n"} 디지털 전환과 협업의 새로운 기준을{"\n"} 만들어가고
                있습니다.
              </p>
            </article>
            <div className={style.partner_list}>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_president.png`}
                  alt="청와대"
                />
                <p className={style.partner_item_title}>청와대</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_lg.png`}
                  alt="LG 화학"
                />
                <p className={style.partner_item_title}>LG 화학</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_mfds.png`}
                  alt="식품의약품안전처"
                />
                <p className={style.partner_item_title}>식품의약품안전처</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_krx.png`}
                  alt="한국증권거래소"
                />
                <p className={style.partner_item_title}>한국증권거래소</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_kdca.png`}
                  alt="질병관리청"
                />
                <p className={style.partner_item_title}>질병관리청</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_gangwon.png`}
                  alt="강원도청"
                />
                <p className={style.partner_item_title}>강원도청</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_lotte.png`}
                  alt="롯데월드타워"
                />
                <p className={style.partner_item_title}>롯데월드타워</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_lx.png`}
                  alt="한국국토정보공사"
                />
                <p className={style.partner_item_title}>한국국토정보공사</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_cn_119.png`}
                  alt="충청남도 소방안전본부"
                />
                <p className={style.partner_item_title}>
                  충청남도 소방안전본부
                </p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_ko_na_rail.png`}
                  alt="한국철도시설공단"
                />
                <p className={style.partner_item_title}>한국철도시설공단</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_gw_119.png`}
                  alt="강원소방본부"
                />
                <p className={style.partner_item_title}>강원소방본부</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_kolonbenit.png`}
                  alt="코오롱베니트"
                />
                <p className={style.partner_item_title}>코오롱베니트</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_posco.png`}
                  alt="포스코플랜텍"
                />
                <p className={style.partner_item_title}>포스코플랜텍</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_taekwang.png`}
                  alt="태광실업"
                />
                <p className={style.partner_item_title}>태광실업</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_namwon.png`}
                  alt="남원시청"
                />
                <p className={style.partner_item_title}>남원시청</p>
              </div>
              <div className={style.partner_item}>
                <img
                  className={style.sm}
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_p4g.png`}
                  alt="2021 서울 녹색미래 정상회의"
                />
                <p className={style.partner_item_title}>
                  2021 서울 녹색미래 정상회의
                </p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_iksan.png`}
                  alt="익산시청"
                />
                <p className={style.partner_item_title}>익산시청</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/cmsmanager/ci_medical.png`}
                  alt="경기도의료원"
                />
                <p className={style.partner_item_title}>경기도의료원</p>
              </div>
            </div>
          </section>
          <section
            className={style.promotion_section}
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/solution/cmsmanager/promotion_bg.png')",
            }}
          >
            <div
              className={style.promotion_item}
              style={{
                backgroundImage:
                  !isMobile && !isTablet
                    ? "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/solution/cmsmanager/promotion_plan_card.png')"
                    : "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/solution/cmsmanager/promotion_plan_card_m.png')",
              }}
            >
              <p className={style.promotion_title}>
                <strong>효율적인 운영과{"\n"} 직관적인 제어</strong>를{"\n"}{" "}
                위한 통합 관리 시스템!
              </p>
              <article className={style.promotion_description}>
                <p>복잡한 회의실을 운영을 간단하게,</p>
                <p>
                  CMS Manager 하나로 스마트하고{"\n"} 안정적인 장비 제어 환경을
                  구축할 수 있습니다.
                </p>
              </article>
            </div>
          </section>
          <Questions />
        </section>
      </section>
    </>
  );
}

export default CmsManager;
